import React from 'react';
import { useSelector } from 'react-redux';
import { PAYMENT_METHODS, CREDITCARD_ICONS } from '../../../../../constants/Payment';
import AccountBedrockDetails from '../../../account-bedrock/AccountBedrockDetails';
import { getImageUrl } from '../../../../../config';

const SubscriptionDetailsWithDefaults = createSubscriptionDetails({ useSelector });

export default SubscriptionDetailsWithDefaults;

export function createSubscriptionDetails({ useSelector }) {
	return function SubscriptionDetails({ paymentDetails }) {
		const { __typename, maskedIban, maskedCreditCardNumber, email, type } =
			paymentDetails?.me?.paymentDetails ?? {};
		const method = PAYMENT_METHODS.find((payment) => payment.graphql_type === __typename);
		const activeSubscription = useSelector((state) => state.subscription.details.data);

		const iconPath = CREDITCARD_ICONS[type] || method?.image;

		if (!activeSubscription) return null;

		const paymentMethod =
			maskedIban || maskedCreditCardNumber || email ? (
				<>
					<p className="payment-method">
						Betaalmethode:
						<span>{method?.title}</span>
					</p>
				</>
			) : null;

		return (
			<div className="subscription-payment-method" data-testid="subscription-details">
				<h2>Mijn betaalgegevens</h2>
				{paymentMethod}
				<div className="subscription-current-payment-method">
					<img
						className="change-payment-details__current__img"
						src={getImageUrl('/images/onboarding/payment-methods/' + iconPath)}
						alt={method?.title}
					/>
					<p>{maskedIban || maskedCreditCardNumber || email}</p>
				</div>
				<AccountBedrockDetails paymentDetails={paymentDetails} />
			</div>
		);
	};
}